module.exports = __webpack_public_path__ + "img/cv.f9922e01.svg";